module.exports = __webpack_public_path__ + "img/Jerk Sandwich-Chicken.15e96413.jpg";